export const RESET = 'EXSBITEMBRAND_LIST_RESET'
export const SET_ITEMS = 'EXSBITEMBRAND_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBITEMBRAND_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBITEMBRAND_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBITEMBRAND_LIST_TOGGLE_LOADING'
